<template>
  <div
    class="main"
    :class="[{ active: visible }, { 'golf-main': isGolfService }]"
  >
    <span> 콘텐츠가 업데이트 되었습니다. </span>
  </div>
</template>

<script>
import { isGolf } from "@/utils/common";

export default {
  data() {
    return {
      visible: false,
      timer: null,
      isGolfService: isGolf,
    };
  },
  mounted() {
    this.$notification.$on("on:visible", (callback) => {
      this.show(callback);
    });
  },
  methods: {
    show(callback) {
      console.log("Toast timer is ticking");
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }

      if (!this.visible) this.visible = true;
      this.timer = setTimeout(() => {
        if (callback) callback();
        this.close();
      }, 5000);
    },
    close() {
      console.log("timer finished");
      clearTimeout(this.timer);
      this.timer = null;
      this.visible = false;
    },
  },

  beforeDestroy() {
    this.$notification.$off("on:visible", this.show);
  },
};
</script>

<style lang="less" scoped>
.main {
  position: absolute;
  opacity: 0;
  top: 0;
  right: 15px;
  width: 320px;
  height: 40px;
  padding: 15px;
  z-index: 9999;
  background-color: #1e1e1e;
  color: #2affcc;
  border-radius: 5px;
  border: 1px solid #eeeeee;
  transition: top 0.5s linear, opacity 0.5s linear;
  display: flex;
  align-items: center;
  justify-content: center;

  &.active {
    top: 15px;
    opacity: 0.9;
    transition: opacity 0.5s ease-out;
  }

  span {
    font-size: 22px;
    letter-spacing: -1px;
    font-weight: 900;
  }

  &.golf-main {
    color: #ff4600;
  }
}

@media all and (min-width: 0px) and (max-width: 1280px) {
  .main {
    box-sizing: content-box;
  }
}
</style>
